import type { QuickAction as AIQuickAction } from "@expert/shared-types";

import type { QuickAction } from "./types";

/**
 * Maps AI-suggested quick actions (from a proactive-guidance payload) into timeline quick actions.
 * The button shows the short `label`; the default click sends the verbose `prompt` back through the
 * assist bot, tagged with the "ProactiveGuidance" source so downstream analytics can tell them apart.
 */
export function toAIQuickActions(aiQuickActions: AIQuickAction[] | undefined): QuickAction[] {
    return (aiQuickActions ?? [])
        .filter((action) => action.type === "SendAssistMessage") // Currently, only "SendAssistMessage" actions are supported.
        .map((action) => ({
            value: action.label,
            prompt: action.prompt,
            source: "ProactiveGuidance",
            analytics: {
                actionId: "ProactiveGuidanceQuickAction",
                eventData: { prompt: action.prompt },
            },
            isVisibleAfterClick: true,
        }));
}
